import { render } from "./Backend.vue?vue&type=template&id=600fe780"
import script from "./Backend.vue?vue&type=script&setup=true&lang=js"
export * from "./Backend.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/home/forge/retail.digitalhq.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/admin/ui/Components/Common/Layouts/Backend.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "600fe780"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('600fe780', __exports__)) {
    api.reload('600fe780', __exports__)
  }
  
  module.hot.accept("./Backend.vue?vue&type=template&id=600fe780", () => {
    api.rerender('600fe780', render)
  })

}


export default __exports__